import React from 'react';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const CustomDatePicker: React.FC<any> = ({
    selected,
    onChange,
    className,
    placeholderText,
    disabled,
    minDate,
    showIcon,
    dateFormat,
    autoComplete,
    name,
    onBlur,
    value,
    ...rest
}) => {
    let parsedValue = null;
    if (selected) {
        parsedValue = dayjs(selected);
    } else if (value && typeof value === 'string' && value !== '0001-01-01' && !value.startsWith('0001-01-01') && value !== '') {
        parsedValue = dayjs(value);
    } else if (value && value instanceof Date) {
        parsedValue = dayjs(value);
    }

    if (parsedValue && !parsedValue.isValid()) {
        parsedValue = null;
    }

    // SetMax date as 1 year from now to prevent users from selecting a date in the far future, which may not be relevant for most use cases.
    const maxDate = dayjs().add(1, 'year');

    return (
        <MuiDatePicker
            label={placeholderText || '"year", "month" and "day"'}
            views={['year', 'month', 'day']}
            value={parsedValue}
            onChange={(newValue) => {
                if (onChange) {
                    onChange(newValue && newValue.isValid() ? newValue.toDate() : null);
                }
            }}
            format="YYYY-MM-DD"
            disabled={disabled}
            minDate={minDate ? dayjs(minDate) : undefined}
            maxDate={maxDate}
            slotProps={{
                textField: {
                    className: className,
                    name: name || rest.name,
                    onBlur: onBlur || rest.onBlur,
                    autoComplete: autoComplete || 'off'
                }
            }}
        />
    );
};

export default CustomDatePicker;
